import { Component } from '@theme/component';

class FlyToCart extends Component {
  source;
  destination;
  useSourceSize = false;
  finished = Promise.resolve();

  connectedCallback() {
    super.connectedCallback();
    if (!this.source || !this.destination || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.remove();
      return;
    }
    const viewport = window.visualViewport;
    const width = viewport?.width || document.documentElement.clientWidth;
    const height = viewport?.height || document.documentElement.clientHeight;
    const left = viewport?.offsetLeft || 0;
    const top = viewport?.offsetTop || 0;
    const size = Math.min(56, width / 7, height / 7);
    const margin = size / 2 + 8;
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const point = (element) => {
      const rect = element.getBoundingClientRect();
      return {
        x: clamp(rect.left + rect.width / 2, left + margin, left + width - margin),
        y: clamp(rect.top + rect.height / 2, top + margin, top + height - margin),
      };
    };
    const start = point(this.source);
    const end = point(this.destination);
    const destinationRect = this.destination.getBoundingClientRect();
    this.style.width = `${size}px`;
    this.style.height = `${size}px`;
    this.style.left = `${start.x - size / 2}px`;
    this.style.top = `${start.y - size / 2}px`;
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    const transform = (progress, scale) => `translate(${dx * progress}px, ${dy * progress}px) scale(${scale})`;
    const motion = this.animate([
      { transform: transform(0, 0.88), opacity: 0, borderRadius: '10px' },
      { transform: transform(0.12, 1), opacity: 1, offset: 0.18, borderRadius: '12px' },
      { transform: transform(0.7, 0.65), opacity: 1, offset: 0.72, borderRadius: '18px' },
      { transform: transform(1, 0.18), opacity: 0, borderRadius: '28px' },
    ], { duration: 620, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)', fill: 'forwards' });
    this.finished = motion.finished.catch(() => {}).then(() => {
      if (this.destination.isConnected && destinationRect.top >= top && destinationRect.bottom <= top + height) {
        this.destination.animate([
          { transform: 'scale(1)' }, { transform: 'scale(1.14)' }, { transform: 'scale(1)' },
        ], { duration: 240, easing: 'ease-out' });
      }
      this.remove();
    });
  }
}

if (!customElements.get('fly-to-cart')) customElements.define('fly-to-cart', FlyToCart);
